module.exports = __webpack_public_path__ + "static/media/dispatch-2.4ada3b81.jpg";